import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Cookies from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import API_PATH from "../../constants/config.json";

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');

const useStyles = makeStyles((theme) => ({
    errorLblMsg: {
        display: 'none'
    },
    root: {
        flexGrow: 1,
        '& .MuiTextField-root': {
            width: '100%',
            '@media only screen and (min-width: 3501px)': {
                marginBottom: '20px',
            },
            '& input': {
                padding: '10px',
                color: '#333',
                '@media only screen and (max-width: 3500px)': {
                    fontSize: '13pt',
                },
                '@media only screen and (min-width: 3501px)': {
                    fontSize: '23pt',
                },
            },
        }
    },
    rootForm: {
        '@media only screen and (max-width: 3500px)': {
            '& h5': {                
                margin: '0',
            }
        },
        '@media only screen and (min-width: 3501px)': {
            '& h5': {
                fontSize: '28pt !important',
                margin: '0',
                marginTop: '10px',
            }
        },
    },
    paper: {
        padding: '0px 0px',
        boxShadow: 'none',
    },
    fieldsetname: {
        width: 'auto',
        border: '1px solid rgba(0, 167, 93, 1)',
        padding: '10px 10px 25px',
        marginTop: '15px',        
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    labelText: {
        width: '100%',
        float: 'left',
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    labelChk: {
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    exportStationBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
            width: '200px',
        },
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    btnContainer: {
        paddingTop: '25px',
        textAlign: 'right'
    },
    approachError: {
        marginBottom: '10px',
        width: '67%',
        '& span': {            
            '@media only screen and (max-width: 3500px)': {
                fontSize: '11pt !important'
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '22pt !important'
            },
        },
        '& .MuiPaper-elevation6': {
            flexGrow: 'unset',
            width: '100%'
        }
    },
}));

const ExportStations = props => {

    const classes = useStyles();

    const [checkedMidblock, setCheckedMidblock] = useState(true);
    const [checkedIntersection, setCheckedIntersection] = useState(true);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [checkedCsv, setCheckedCsv] = useState(true);
    const [checkedGeoJson, setCheckedGeoJson] = useState(false);
    const [checkedShape, setCheckedShape] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [errPopUp, setErrPopUp] = useState(false);

    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');

    const [disabledBtnExport, setDisabledBtnExport] = useState(false);

    useEffect(
        () => {
            getAswToken();
        }, []
      )

    const validateForm = (e) => {
        setErrorMsg("");
        if(!checkedMidblock && !checkedIntersection) {
            setErrPopUp(true);
            setErrorMsg("You need to choose at least one station type.");
            return;
        }
        if(!checkedCsv && !checkedGeoJson && !checkedShape) {
            setErrPopUp(true);
            setErrorMsg("You need to choose at least one export format.");
            return;
        }

        exportStations();
    }

    const exportStations = () => {
        try {
            axios({
                method: 'POST',
                data: {
                    startDate,
                    endDate,
                    checkedMidblock,
                    checkedIntersection,
                    checkedCsv,
                    checkedShape,
                    checkedGeoJson
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.exportStations,
            })
                .then(async function (response) {
                    setDisabledBtnExport(true);
                    let OIDToken = Cookies.get('idToken');
                    AWS.config.update(
                        {
                          region: 'us-west-2',
                          credentials: new AWS.CognitoIdentityCredentials({
                            IdentityPoolId: idintityPool,
                            Logins: {
                              [aswLogins]: OIDToken
                            }
                          })
                        }
                    );
                    let s3 = new AWS.S3();                    
                    s3.getObject({ Bucket: response.data.data.bucket_name, Key: 'downloads/'+response.data.data.file_name }, function (
                    error,
                    data
                    ) {
                    if (error != null) {
                        console.log('error',error);
                        setDisabledBtnExport(false);
                    } else {                        
                        let blob = new Blob([data.Body], { type: data.ContentType });
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = response.data.data.file_name ;
                        link.click();
                        setDisabledBtnExport(false);
                    }
                    });
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {
            console.error(error);
        }
    }
    //This method is use for get aws token for file download .... start
  const getAswToken = () => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getAWSs3TokenAPI,
        headers: {
          'agencyid': sessionStorage.getItem('agency_id'),
          'payload': Cookies.get('payload'),
        },
      }).then(async function (response) {
        if (response.status && response.status == '200') {
          let aswData = response.data;
          setIdintityPool(aswData.data.IdentityPoolId);
          setAswLogins(aswData.data.Logins);
        } else {
          console.log("");
        }
      })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for get aws token for file download .... end

    const ShowErrPopUP = () => {
        setErrPopUp(false)
    };

    return (
        <>
            <div className={classes.root}>
                <p style={{ marginBottom: '10px', marginTop: '0' }}>
                    <NavLink to="#" style={{ color: '#24618E' }} onClick={props.stationtabBack}>
                        <FontAwesomeIcon icon={faAngleLeft} />&nbsp;Return to Station List
                    </NavLink>
                </p>
                <form className={classes.rootForm} noValidate autoComplete="off" data-testid='export_stations_form'>
                    <Grid container>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={5}>
                                <h5>Export Stations</h5>
                            </Grid>
                        </Grid>
                        <label data-testid="errorMsg" className={classes.errorLblMsg}>{errorMsg}</label>
                        {errorMsg !== "" ? <div className={classes.approachError}>  <ErrorMessage message={errorMsg} visible={ShowErrPopUP} show={errPopUp} msgType="error" /> </div> : null}
{/*                         
                        <Grid item xs={12} sm={8}>
                            <fieldset className={classes.fieldsetname}>
                                <legend>Date Range</legend>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>Start Date</label>
                                            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <label className={classes.labelText}>End Date</label>
                                            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </fieldset>
                        </Grid> */}
                        <Grid item xs={12} sm={8} data-testid="stationTypeContainer">
                            <fieldset className={classes.fieldsetname}>
                                <legend>Station Type</legend>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <input data-testid="midblockType" id="mdChk" type="checkbox" checked={checkedMidblock} onClick={(e) => setCheckedMidblock(!checkedMidblock)} />
                                            <label className={classes.labelChk} for="mdChk">Midblock</label>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Paper className={classes.paper}>
                                            <input data-testid="intersectionType" id="intChk" type="checkbox" checked={checkedIntersection} onClick={(e) => setCheckedIntersection(!checkedIntersection)} />
                                            <label className={classes.labelChk} for="intChk">Intersection</label>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </fieldset>
                        </Grid>
                        <Grid item xs={12} sm={8} data-testid="exportFormatContainer">
                            <fieldset className={classes.fieldsetname}>
                                <legend>Export Format</legend>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4}>
                                        <Paper className={classes.paper}>
                                            <input data-testid="csvFormat" id="csvChk" type="checkbox" checked={checkedCsv} onClick={(e) => setCheckedCsv(!checkedCsv)} />
                                            <label className={classes.labelChk} for="csvChk">CSV</label>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Paper className={classes.paper}>
                                            <input data-testid="shapeFormat" id="shapeChk" type="checkbox" checked={checkedShape} onClick={(e) => setCheckedShape(!checkedShape)} />
                                            <label className={classes.labelChk} for="shapeChk">Shapefile</label>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Paper className={classes.paper}>
                                            <input data-testid="geojsonFormat" id="geoChk" type="checkbox" checked={checkedGeoJson} onClick={(e) => setCheckedGeoJson(!checkedGeoJson)} />
                                            <label className={classes.labelChk} for="geoChk">Geojson</label>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </fieldset>
                        </Grid>
                        <Grid item xs={12} sm={8} className={classes.btnContainer}>
                            <Button 
                                type="button" 
                                variant="outlined" 
                                data-testid="export_stations_btn"
                                className={classes.exportStationBtn}
                                onClick={validateForm}
                                disabled={disabledBtnExport}
                            >
                                {(!disabledBtnExport)? 'Export' : <CircularProgress color="secondary" size={30} style={{color:'white'}}/>}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </>
    )
}

export default ExportStations;